import { GameObject } from "../core/GameObject";
import { GameScene } from "../scenes/GameScene";
import { DestroyOffscreen } from "./DestroyOffscreen";
import { PlanckBodyComponent, PlanckBodyType } from "./PlanckBodyComponent";

export class Ground extends GameObject {

	img: Phaser.GameObjects.Image;
	
	constructor(scene: GameScene, x: number, y: number, image?: string) {
		super(scene);

		this.x = x;
		this.y = y;

		const img = this.img = this.addImage(image ? image : "bedrockFloor");
		img.setOrigin(0, 0.5);
		this.setSize(img.width, img.height);
		this.addComponent(new PlanckBodyComponent(this, PlanckBodyType.BOX, {
			x: this.x, y: this.y,
			width: img.displayWidth, height: img.displayHeight * 0.25,
			worldScale: GameScene.worldScale,
			isStatic: true,
		}));

		this.addComponent(new DestroyOffscreen(this, true, false, 500));
	}

	cropWidth(overflow: number): void {
		this.img.setCrop(0, 0, this.width - overflow, this.height);
	}
}